import { FormProvider, useForm, type FieldErrors } from 'react-hook-form'

import { initialFormValues } from './form/initialFormValues'
import { useConsumption } from '@pages/Consumption/context'
import { CloseIcon } from '@assets/svgs/CloseIcon'
import { FilterIcon } from '@assets/svgs/FilterIcon'
import { Button } from '@components/shared/Button'
import { RowBox } from '@components/shared/RowBox'
import { Select } from '@components/shared/Select'

import type { WeeklyBreakdownConsumptionFiltersFormProps } from './form/types'
import type { WeeklyBreakdownConsumptionFiltersProps } from './types'

import * as S from './styles'

export const WeeklyBreakdownConsumptionFilters = ({ onFilter }: WeeklyBreakdownConsumptionFiltersProps) => {
  const { weeklyBreakdownData, isWeeklyBreakdownLoading } = useConsumption()

  const methods = useForm<WeeklyBreakdownConsumptionFiltersFormProps>({
    defaultValues: initialFormValues
  })

  const onError = (errors: FieldErrors<WeeklyBreakdownConsumptionFiltersFormProps>) => console.log({ errors })

  const onSubmit = (formData: WeeklyBreakdownConsumptionFiltersFormProps) => onFilter(formData)

  return (
    <FormProvider {...methods}>
      <RowBox columns={5} marginTop={16} marginBottom={24}>
        <Select
          name="supplier"
          label="Fornecedor"
          options={
            weeklyBreakdownData?.availableFilters?.suppliers.map((item) => ({
              label: item.code != "0" ? `${item.code} - ${item.name}` : `${item.name}`,
              value: item.code
            })) || []
          }
          disabled={isWeeklyBreakdownLoading}
        />
        <Select
          name="origin"
          label="Origem"
          options={
            weeklyBreakdownData?.availableFilters?.origins.map((item) => ({
              label: item,
              value: item
            })) || []
          }
          disabled={isWeeklyBreakdownLoading}
        />
        <Select
          name="classification"
          label="Classificação"
          options={
            weeklyBreakdownData?.availableFilters?.itemClassifications.map((item) => ({
              label: item,
              value: item
            })) || []
          }
          disabled={isWeeklyBreakdownLoading}
        />
        <Select
          name="operation"
          label="Operação"
          options={
            weeklyBreakdownData?.availableFilters?.operations.map((item) => ({
              label: item.code != "0" ? `${item.code} - ${item.name}` : `${item.name}`,
              value: item.code
            })) || []
          }
          disabled={isWeeklyBreakdownLoading}
        />

        <S.FilterButtons>
          <Button
            width="100%"
            colorType="outlineBlue"
            rightIcon={<FilterIcon />}
            onClick={() => methods.handleSubmit(onSubmit, onError)()}
            disabled={isWeeklyBreakdownLoading}
          >
            Filtrar
          </Button>

          <Button
            width="100%"
            colorType="outlineBlue"
            rightIcon={<CloseIcon />}
            onClick={() => {
              methods.reset()
              onFilter(initialFormValues)
            }}
            disabled={isWeeklyBreakdownLoading}
          >
            Limpar
          </Button>
        </S.FilterButtons>
      </RowBox>
    </FormProvider>
  )
}
